<template>
    <div class="login">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">{{ $t("login") }}</div>
                        <div class="card-body">
                            <form @submit.prevent="handleSubmit">
                                <div class="form-group row">
                                    <label for="email_address" class="col-md-4 col-form-label text-md-right">E-Mail Address</label>
                                    <div class="col-md-6">
                                        <input type="text" v-model="email" name="email" class="form-control"
                                        autofocus :class="{ 'is-invalid': submitted && !email }" />
                                        <div v-show="submitted && !email" class="invalid-feedback">Email is required</div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>
                                    <div class="col-md-6">
                                        <input type="password" v-model="password" name="password" class="form-control" 
                                            :class="{ 'is-invalid': submitted && !password }" />
                                        <div v-show="submitted && !password" class="invalid-feedback">Password is required</div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <ul class="errors-list">
                                        <li class="d-inline-block" :key="item" v-for="item in errors">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>

                                <!-- <div class="form-group row">
                                    <div class="col-md-6 offset-md-4">
                                        <div class="checkbox">
                                            <label>
                                                <input type="checkbox" name="remember"> Remember Me
                                            </label>
                                        </div>
                                    </div>
                                </div> -->

                                <div class="col-md-6 offset-md-4">
                                    <button type="submit" :disabled="status.loggingIn" class="btn btn-primary">
                                        <img v-show="status.loggingIn" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                        {{$t("login")}}
                                    </button>
                                    <router-link class="btn btn-link" replace :to="{ name: 'forgotPassword'}">
                                        {{$t('actions.forgotPassword')}}
                                    </router-link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      status: {
        loggingIn: false
      },
      errors: []
    };
  },
  computed: {
    //...mapState('account', ['status'])
  },
  created() {
    // reset login status
    //this.logout();
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    handleSubmit(e) {
      console.log(e);
      this.submitted = true;
      this.status.loggingIn = true;
      const { email, password } = this;
      if (email && password) {
        this.login({ email, password })
          .then(result => {
            console.log(this, this.$router, result);
            this.status.loggingIn = false;
            this.$router.push(this.$route.query.redirect || '/profile')
            //this.$router.push("/profile");
          })
          .catch(err => {
            console.log(err);            
            this.errors.length = 0;
            err.forEach(function(v) {
              this.errors.push(v);
            }, this);
            this.status.loggingIn = false;
          });
      }
    }
  }
};
</script>

<style>
    .login {
    padding: 10px;
    }

    .login .form-group label {
    margin-right: 15px;
    }

    .login .form-group {
    margin: 15px 0;
    }

    .mr-10 {
    margin-right: 10px;
    }
    
    .ml-10 {
    margin-right: 10px;
    }
</style>